import axios from 'axios'

import {images} from './imageExporter';

export const fetchHealthData = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?country=se&pageSize=4&category=health&sortBy=popularity&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Health',
          source: 'health'
        }
      })
      callback(posts);
    })
}

export const fetchHealthDataBig = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?country=se&category=health&sortBy=popularity&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Health',
          source: 'health'
        }
      })
      callback(posts);
    })
}

export const fetchTransactionsDataUS = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?category=business&pageSize=2&country=us&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Transactions',
          source: 'transactions'
        }
      })
      callback(posts);
    })
}

export const fetchTransactionsDataUK = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?category=business&pageSize=2&country=gb&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Transactions',
          source: 'transactions'
        }
      })
      callback(posts);
    })
}

export const fetchTransactionsDataUKBig = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?category=business&pageSize=8&country=gb&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Transactions',
          source: 'transactions'
        }
      })
      callback(posts);
    })
}

export const fetchTransactionsDataUSBig = (callback) => {
  const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

  return axios
    .get(
      `https://newsapi.org/v2/top-headlines?category=business&pageSize=8&country=us&apiKey=${API_KEY}`
    )
    .then(res => {
      const posts = res.data.articles.map(post => {
        return {
          background: `url(${post.urlToImage})`,
          imgSrc: post.urlToImage,
          logo: images.verge_logo,
          title: post.title,
          url: post.url,
          author: post.author,
          postType: 'Transactions',
          source: 'transactions'
        }
      })
      callback(posts);
    })
}

export const fetchConnectivityData = (callback) => {
  return axios.get(`https://www.reddit.com/r/iot.json`).then(res => {
    // console.log(res.data.data.children);
    const posts = res.data.data.children.filter(({ data }) => !data.title.startsWith(`[META]`))
      .map(({ data }, i) => {
        return {
          // thumbnail: data.thumbnail === 'default' || data.thumbnail === 'self' || data.thumbnail === 'image' ? images.reddit_logo : data.thumbnail,
          background: data.thumbnail === 'default' || data.thumbnail === 'self' || data.thumbnail === 'image' || !data.preview ? `url(${images.connectivity_bg})` : `url(${data.preview.images[0].source.url})`,
          logo: images.reddit_logo,
          title: data.title,
          source: 'connectivity',
          url: `https://www.reddit.com/${data.permalink}`,
        }
      })
    callback(posts);
  }
  )
}

export const fetchPublicSectorData = (callback) => {

  return axios
    .get(
      `https://api.rss2json.com/v1/api.json?rss_url=https://ted.europa.eu/TED/rss/CustomRSSFeedGenerator/324000/en`
    )
    .then(res => {
      console.log(res.data.items);
      const posts = res.data.items.map(post => {
        return {
          background: `url(${images.public_sector_bg})`,
          // imgSrc: post.urlToImage,
          // logo: images.verge_logo,
          title: post.title,
          url: post.link,
          // author: post.author,
          postType: 'Public Sector',
          source: 'publicSector'
        }
      })
      callback(posts);
    })
}


  // fetchHealthData(posts => {
  //   console.log(posts);

  //   dataArr.push(posts);
  // })

// export const fetchAllTransactions = (callback) => {
//   const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

//   const fetchBusinessUsData = axios
//     .get(
//       `https://newsapi.org/v2/top-headlines?category=business&pageSize=2&country=us&apiKey=${API_KEY}`
//     )
//     .then(res => {
//       const posts = res.data.articles.map(post => {
//         return {
//           background: `url(${post.urlToImage})`,
//           imgSrc: post.urlToImage,
//           logo: images.verge_logo,
//           title: post.title,
//           url: post.url,
//           author: post.author,
//           postType: 'Health',
//           source: 'health'
//         }
//       })
//     });

//   const fetchBusinessGbData = axios
//     .get(
//       `https://newsapi.org/v2/top-headlines?category=business&pageSize=2&country=gb&apiKey=${API_KEY}`
//     )
//     .then(res => {
//       const posts = res.data.articles.map(post => {
//         return {
//           background: `url(${post.urlToImage})`,
//           imgSrc: post.urlToImage,
//           logo: images.verge_logo,
//           title: post.title,
//           url: post.url,
//           author: post.author,
//           postType: 'Health',
//           source: 'health'
//         }
//       })
//     });

//   Promise.all([fetchBusinessGbData, fetchBusinessUsData]).then(posts => callback(posts))
// }

// export const fetchWiredData = (callback) => {
//   const API_KEY = process.env.GATSBY_NEWSAPI_KEY;

//   return axios
//     .get(
//       `https://newsapi.org/v2/top-headlines?sources=wired&apiKey=${API_KEY}`
//     )
//     .then(res => {
//       const posts = res.data.articles.map(post => {
//         return {
//           background:`url(${post.urlToImage})`,
//           imgSrc: post.urlToImage,
//           logo: images.wired_logo,
//           title: post.title,
//           url: post.url,
//           author: post.author.startsWith('Geek') ? 'Geek\'s Guide to the Galaxy' : post.author,
//           postType: 'Latest',
//           source: 'wired'
//         }
//       })
//       callback(posts);
//     })
// }


// export const fetchProductHuntData = (callback) => {
//   const devToken = process.env.GATSBY_PRODUCTHUNT_KEY;

//   let config = {
//     headers: {
//       Authorization: `bearer ${devToken}`,
//     },
//   }

//   return axios
//     .get(`https://api.producthunt.com/v1/me/feed`, config)
//     .then(res => {
//       const posts = res.data.posts.map((post, i) => {
//         return {
//           thumbnail: post.thumbnail.image_url ? post.thumbnail.image_url.split('?')[0] : images.producthunt_logo,
//           imgSrc: post.thumbnail.image_url ? post.thumbnail.image_url.split('?')[0] : images.producthunt_logo,
//           logo: images.producthunt_logo,
//           title: post.name,
//           url: post.discussion_url,
//           meta: {
//             comments: post.comments_count,
//             votes: post.votes_count
//           },
//           latest: post.created_at,
//           tagline: post.tagline,
//           index: i
//         }
//       })
//       callback(posts);
//     })
// }

// export const fetchRedditData = (callback) => {
//   return axios.get(`https://www.reddit.com/r/assholedesign.json`).then(res => {
//     const posts = res.data.data.children.filter(({ data }) => !data.title.startsWith(`[META]`))
//       .map(({ data }, i) => {
//         return {
//           thumbnail: data.thumbnail === 'default' || data.thumbnail === 'self' || data.thumbnail === 'image' ? images.reddit_logo : data.thumbnail,
//           imgSrc: data.thumbnail === 'default' || data.thumbnail === 'self' || data.thumbnail === 'image' ? images.reddit_logo : data.thumbnail,
//           logo: images.reddit_logo,
//           title: data.title,
//           url: `https://www.reddit.com/${data.permalink}`,
//           meta: {
//             comments: data.num_comments,
//             votes: data.ups
//           },
//           latest: data.created,
//           index: i
//         }
//       })
//     callback(posts);
//   }
//   )
// }

// export const fetchDNData = (callback) => {
//   axios.get('https://www.designernews.co/api/v2/stories').then(res => {
//     const posts = res.data.stories.map((post, i) => {
//       return {
//         background: `url(${images[post.badge + '_large'] ? images[post.badge + '_large'] : images.unspecified_large})`,
//         imgSrc: images[post.badge] ? images[post.badge] : images.unspecified,
//         logo: images.designernews_logo,
//         title: post.title,
//         url: `https://www.designernews.co/stories/${post.id}`,
//         meta: {
//           comments: post.comment_count,
//           votes: post.vote_count
//         },
//         latest: post.created_at,
//         index: i
//       }
//     })
//     callback(posts)
//   })
// }

// export const fetchHackerNewsData = (callback) => {
//   axios.get('https://node-hnapi.herokuapp.com/news').then(res => {
//     const posts = res.data.map((post, i) => {
//       const thumbnail = (post.title.startsWith('Ask HN')) ? (images.ask_hn) : ((post.title.startsWith('Show HN')) ? (images.show_hn) : (images.unspecified_hn));
//       const image = (post.title.startsWith('Ask HN')) ? (images.ask_hn_large) : ((post.title.startsWith('Show HN')) ? (images.show_hn_large) : (images.unspecified_hn_large));
//       return {
//         // thumbnail: image,
//         background: `url(${image})`,
//         imgSrc: thumbnail,
//         logo: images.hackernews_logo,
//         title: post.title,
//         url: `https://news.ycombinator.com/item?id=${post.id}`,
//         meta: {
//           comments: post.comments_count,
//           votes: post.points
//         },
//         latest: post.time,
//         index: i
//       }
//     })
//     callback(posts)
//   })
// }

// export const fetchAll = (callback) => {
//   const data = {
//     'dn': {},
//     // 'reddit': {},
//     'productHunt': {},
//     'hackernews': {},
//     'verge': [],
//     'wired': [],
//   };

//   const dataArr = [];

  // const filterPosts = (postsArr, source) => {
  //   let newPosts;

  //   data[source].hottest = { ...postsArr.sort((a, b) => a.meta.votes < b.meta.votes ? 1 : -1)[0], postType: 'Hottest' };
  //   dataArr.push({ ...postsArr.sort((a, b) => a.meta.votes < b.meta.votes ? 1 : -1)[0], postType: 'Hottest', source: source });

  //   newPosts = postsArr.slice(1);

  //   data[source].mostCommented = { ...newPosts.sort((a, b) => a.meta.comments < b.meta.comments ? 1 : -1)[0], postType: 'Most Commented' };
  //   dataArr.push({ ...newPosts.sort((a, b) => a.meta.comments < b.meta.comments ? 1 : -1)[0], postType: 'Most Commented', source: source });

  //   newPosts = newPosts.slice(1);

  //   data[source].trending = { ...newPosts.sort((a, b) => a.index > b.index ? 1 : -1)[0], postType: 'Trending' };
  //   dataArr.push({ ...newPosts.sort((a, b) => a.index > b.index ? 1 : -1)[0], postType: 'Trending', source: source });

  //   newPosts = newPosts.slice(1);

  //   data[source].latest = { ...newPosts.sort((a, b) => a.created < b.created ? 1 : -1)[0], postType: 'Latest' };
  //   dataArr.push({ ...newPosts.sort((a, b) => a.created < b.created ? 1 : -1)[0], postType: 'Latest', source: source });

  //   callback(data, dataArr);
  // };

  // fetchDNData(posts => {

  //   filterPosts(posts, 'dn');

  // });

  // fetchHackerNewsData(posts => {
  //   filterPosts(posts, 'hackernews')
  // });

  // fetchRedditData(posts => {

  //   filterPosts(posts, 'reddit');

  // });

  // fetchProductHuntData(posts => {
  //   filterPosts(posts, 'productHunt');
  // });

//   fetchHealthData(posts => {
//     console.log(posts);

//     dataArr.push(posts);
//   })



// }



// WEBPACK FOOTER //
// ./src/utils/api.js